import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '../api/portalApi';

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!token) {
      setError(t('resetPassword.invalidLink'));
      return;
    }
    if (password !== confirm) {
      setError(t('resetPassword.noMatch'));
      return;
    }
    if (password.length < 8) {
      setError(t('resetPassword.tooShort'));
      return;
    }

    setIsLoading(true);
    try {
      await resetPassword(token, password);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('resetPassword.expired'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="investor-login-shell">
      <div className="investor-login-logo">
        <img src="/logos/nomadme_sourcing_trading_mark.png" alt="nomadme" />
      </div>
      <p className="investor-login-brand">NomadMe</p>

      <section className="investor-login-card">
        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>✅</div>
            <h2 style={{ color: '#c8a06a' }}>{t('resetPassword.success')}</h2>
            <p style={{ color: '#94a3b8' }}>{t('resetPassword.redirecting')}</p>
          </div>
        ) : (
          <>
            <Link to="/login" className="auth-back-link">{t('resetPassword.backToLogin')}</Link>
            <h2>{t('resetPassword.title')}</h2>
            <p className="investor-login-subtitle">{t('resetPassword.sub')}</p>

            <form className="investor-login-form" onSubmit={handleSubmit}>
              <div className="investor-login-field">
                <label htmlFor="password">{t('resetPassword.newPassword')}</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t('resetPassword.passwordPlaceholder')}
                  minLength={8}
                  required
                  autoComplete="new-password"
                />
              </div>
              <div className="investor-login-field">
                <label htmlFor="confirm">{t('resetPassword.confirmPassword')}</label>
                <input
                  id="confirm"
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder={t('resetPassword.confirmPlaceholder')}
                  required
                  autoComplete="new-password"
                />
              </div>
              {error && <p className="investor-login-error">{error}</p>}
              <button type="submit" disabled={isLoading} className="investor-login-btn">
                {isLoading ? t('resetPassword.updating') : t('resetPassword.submit')}
              </button>
            </form>
          </>
        )}
      </section>
    </main>
  );
};

export default ResetPasswordPage;
